// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FqGZ","toggleWrap":"styles_toggleWrap__2A2w7","content":"styles_content__ku3A8","selectAreaCode":"styles_selectAreaCode__1-YC_"};